export default {
	props: {

	},
	data() {
		return {

		}
	},
	created() {

	},
	methods: {
		wecomLogin() {
			
			let authCode = this.getRedirectUri(window.location.href, 'code')
			if (!authCode) {
				this.wecomLoginHref()
			} else {
				if (this.$store.state.system.systemdata) {
					this.$emit('login')
					return
				}
				// alert(authCode)
				this.$api.wecomlogin({
					authCode: authCode,
					appid:window.config.wecom.appid,
					agentid:window.config.wecom.agentid
				}).then((res) => {
					// console.log(res)
					this.authlogin(res)
				}, () => {
					this.wecomLoginHref()
				})
			}
		},
		wecomLoginHref() {
			let redirect_uri = this.getRedirectUri(window.config.wecom.authurl, 'redirect_uri')
			redirect_uri = encodeURIComponent((redirect_uri ? redirect_uri : window.config.wecom.authurl) + '?logincompany=' +
				this.logincompany)
			window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + window.config.wecom
				.appid + '&redirect_uri='+redirect_uri+'&response_type=code&scope=snsapi_privateinfo&state=STATE&agentid=' + window
				.config.wecom.agentid + '#wechat_redirect'

		},
	},
}